/**
 * Material Description Component
 *
 * Renders markdown description for materials.
 */

import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getLocalizedDescription, type Material } from '@immopersian/common';

interface MaterialDescriptionProps {
  material: Material;
}

export function MaterialDescription({ material }: MaterialDescriptionProps) {
  const { i18n } = useTranslation();

  if (!material.description) return null;

  return (
    <div className="prose prose-gray max-w-none">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {getLocalizedDescription(material, i18n.language)}
      </ReactMarkdown>
    </div>
  );
}
